require('normalize.css/normalize.css');
require('styles/App.css');

import React,{Component} from 'react';

import Header from '../components/HeaderComponent'
import Footer from '../components/FooterComponent'

import Home from '../components/HomeComponent'
import Stats from '../components/StatsComponent'
import Apps from '../components/AppsComponent'
import Contact from '../components/ContactComponent'
import Sitemap from '../components/SitemapComponent'
import DpsObl from '../components/DpsOblComponent'
import DpsRaion from '../components/DpsRaionComponent'
import Mother from '../components/MotherComponent'
import Archives from '../components/ArchivesComponent'


//let yeomanImage = require('../images/yeoman.png');

class AppComponent extends Component {
constructor(props) {
    super(props)
    this.state = {
      route: window.location.hash.substr(1)
    }
  }
  componentDidMount() {
    window.addEventListener('hashchange', () => {
      this.setState({
        route: window.location.hash.substr(1)
      })
    })
  }
  render() {
    let Child

    switch (this.state.route) {
      case '/home': Child = Home; break;
      case '/stats': Child = Stats; break;
      case '/apps': Child = Apps; break;
      case '/contact': Child = Contact; break;
      case '/sitemap': Child = Sitemap; break;
      case '/dpsobl': Child = DpsObl; break;
      case '/dpsraion': Child = DpsRaion; break;
      case '/mother': Child = Mother; break;
      case '/archives': Child = Archives; break;
      default: Child = Stats;
    }

    return (
      <div>
        <div className="tail-top-right"></div>
          <div className="tail-top">
           <div className="tail-bottom">
              <div className="main" id="main">
                <Header/>
                <Child />
                <Footer/>
              </div>
           </div>
        </div>
      </div>
    )
  }
  /*render() {
    return (
      <div className="index">
        <img src={yeomanImage} alt="Yeoman Generator" />
        <div className="notice">Please edit <code>src/components/Main.js</code> to get started!</div>
      </div>
    );
  }*/
}

// AppComponent.defaultProps = {
// };

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js